import { useCallback, useEffect, useMemo, useState, useRef } from 'react';
import { Box, ButtonBase, InputBase, makeStyles, TextField, FormControlLabel, Checkbox } from '@material-ui/core';
import _, { isArray, isFunction } from 'lodash';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { DateTimePicker } from '@material-ui/pickers';
import { AutoCompleteSelect } from '../../../../components';
import DiaLog from '../../../../components/Dialog';
import { i18n } from '../../../../language';
import StyleButton from '../../../../components/StyleButton';
import { AddIcon, CloseIcon, DropDownIcon, DropUpIcon, ScanIcon } from '../../../../components/Icon';
import useBarcodeListener from '../../../../utils/useBarcodeListener';
import { useScanPage } from '../../../../utils/useScanQrcode';
import EquipmentAsset from '../../../../components/EquipmentAsset';
import { equipmentAPI, systemAPI } from '../../../../apis';
import {
  ADS_LAST_ORDER_STATUS,
  EQUIPMENT_LENGTH,
  EQUIPMENT_REQUEST_DATE_FORMAT,
  REMARKS_FIELD,
  REQUEST_STATUS_ENUM,
} from '../../../../comm/constant';
import useMobile from '../../../../utils/useMobile';
import { alertMsg } from '../../../../apis/commlogic';
import { classNames, conditional, getUUID, initValue, useGetUserInfo } from '../../../../utils';
import {
  DWP_COMM_REMARK_BMS_ISFA,
  DWP_COMM_REMARK_BMS_L,
  DWP_COMM_REMARK_BMS_M,
  DWP_COMM_REMARK_BMS_S,
} from '../../../../comm/commandQRcode';
import SingleADSDialog from '../ADS/SingleADSDialog';
import AutoCompleteInput from '../../../../components/AutoCompleteInput';
import { TransferHistory } from '../HistoryLog';
import { handleScanHkid, handleScanPatientQrCode } from '../NewLoanRequestDialog';
import MultipleInput from '../../../../components/MultipleInput';
import RedStar from '../../../../components/RedStar';
import { getCentralStoreAvailableQty, handleDeleteReceipt, handleMultiReceiptEnter, getMutiReceiptVal } from '../Util';
import useGetRemarksListAPI from '../../hooks/useGetRemarksListAPI';
import AddRemarks from '../../../../components/AddRemarks';
import Text from '../../../../components/Text';

const useStyles = makeStyles((theme) => ({
  title: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    color: '#7d86a9',
  },
  date: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '1.125rem',
    color: '#2e4469',
  },
  wardAutoSelect: {
    marginTop: '1rem',
  },
  inputBase: ({ error }) => ({
    border: error ? 'solid 1px #f44336' : 'solid 1px #e4e7eb',
    borderRadius: '10px',
    height: '3.5rem',
    width: '24.5rem',
    padding: '0 1.25rem',
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    color: '#2e4469',
  }),
  errorMsg: {
    color: '#f44336',
    margin: '0.5rem 0.5rem 0',
    fontFamily: 'NotoSans-Medium',
    fontWeight: '500',
  },
  otherInfoBtn: {
    cursor: 'pointer',
  },
  dropDownButton: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '1.5rem',
    height: '1.5rem',
    marginRight: '1.25rem',
  },
  dropDownIcon: {
    fontSize: '0.938rem',
    color: '#3e3e3e',
  },
  otherInformationTitle: {
    fontSize: '1.125rem',
    color: '#3e3e3e',
  },
  scanButton: {
    marginBottom: '0.375rem',
    flexBasis: '66%',
    marginTop: '1.5rem',
  },
  scanIcon: {
    color: '#538fff',
  },
  star: {
    color: '#ff0300',
  },
  requestID: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '1.313rem',
    color: '#1973e6',
    height: '1.75rem',
  },
  status: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    color: '#2e4469',
    height: '1.75rem',
    display: 'flex',
    alignItems: 'center',
  },
  statusIcon: {
    width: '0.625rem',
    height: '0.625rem',
    minWidth: '0.625rem',
    minHeight: '0.625rem',
    borderRadius: '50%',
    marginRight: '0.625rem',
  },
  timePicker: {
    width: '100%',
    '& .MuiInputBase-root': {
      borderRadius: '0.625rem',
      border: '0.0625rem solid #E4E7EB',
      fontSize: '1rem',
      color: theme.palette.font.main,
      fontWeight: 'normal',
      width: '12.75rem',
      height: '3.5rem',
      cursor: 'pointer',
    },
    '& .MuiButtonBase-root': {
      borderRadius: '0',
      '&:hover': {
        backgroundColor: theme.palette.font.white,
      },
    },
    '& .MuiOutlinedInput-notchedOutline': {
      display: 'none',
    },
    '& .MuiInputBase-input': {
      cursor: 'pointer',
      fontFamily: 'NotoSans-Medium !important',
      textAlign: 'center',
      fontSize: '1.125rem',
    },
  },
  timepickerError: {
    '& .MuiInputBase-root': {
      borderColor: '#f44336 !important',
    },
  },
  warningContent: {
    fontFamily: 'NotoSans-Bold',
    fontSize: '1rem',
    lineHeight: '1.875rem',
    letterSpacing: '0',
    color: '#2e4469',
    fontWeight: 'bold',
  },
  textField: {
    borderRadius: '0.625rem',
    border: 'solid 1px #e4e7eb',
    padding: '0 1rem',
    '& .MuiInputBase-root': {
      fontFamily: 'NotoSans-Medium',
      fontSize: '1rem',
      color: '#2e4469',
      lineHeight: '1.8rem',
    },
    '& :before': {
      content: 'none',
    },
    '& :after': {
      content: 'none',
    },
  },
  adsContent: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    color: '#2e4469',
  },
  addTransfer: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    color: '#1973e6',
  },
  addIcon: {
    width: '1.125rem',
    height: '1.125rem',
    color: '#1973e6',
    marginRight: '0.513rem',
  },
  AdsText: {
    color: '#9ea6c2',
    marginTop: '0.5rem',
  },
  checkBox: {
    '& .MuiCheckbox-root': {
      color: '#c0c6cb',
    },
    '& .MuiTypography-root': {
      fontFamily: 'NotoSans-Medium',
      fontSize: '1rem',
      fontWeight: '500',
      color: '#2e4469',
    },
    '& .Mui-checked': {
      color: '#28d2ab',
    },
  },
  xing: {
    color: 'red',
    marginRight: '0.5rem',
    marginTop: '0.5rem',
  },
  assetItemContain: {
    display: 'flex',
    padding: '0rem 1.42rem',
    width: '100%',
    fontSize: '1.1rem',
    '&:hover': {
      backgroundColor: '#F5FAFF',
    },
    '&:hover $assetItemText': {
      color: '#538FFF',
    },
  },
  assetItemText: {
    width: '33%',
  },
}));

const TitleInput = ({
  title,
  placeholder,
  flexBasis,
  value,
  onChange,
  endAdornment,
  handleEnter,
  onFocus,
  onBlur,
  length = 'unset',
  error,
  errorMsg,
  readOnly = false,
  id,
  required = false,
}) => {
  const classes = useStyles({ error });

  const inputHandler = (event) => {
    if (isFunction(onChange)) {
      onChange(event.target.value);
    }
  };

  const onKeyDownHandler = (event) => {
    if ((event.code === 'Enter' || event.code === 'NumpadEnter') && isFunction(handleEnter)) {
      handleEnter(event.target.value);
    }
  };

  return (
    <Box display="flex" flexDirection="column" flexBasis={flexBasis}>
      <div className={classes.title}>
        {title}
        {required && <RedStar />}
      </div>
      <InputBase
        id={id}
        className={classes.inputBase}
        placeholder={placeholder}
        style={{ width: '100%', marginTop: '1.063rem' }}
        onChange={inputHandler}
        value={value}
        endAdornment={endAdornment}
        onKeyDown={onKeyDownHandler}
        onFocus={onFocus}
        onBlur={onBlur}
        inputProps={{ maxLength: length }}
        readOnly={readOnly}
      />
      {error && <div className={classes.errorMsg}>{i18n.t(errorMsg)}</div>}
    </Box>
  );
};

const emptyEquipment = {
  category: '',
  categoryName: '',
  availableQty: 0,
  assets: [],
  loanQty: 1,
};

const handleRemoveCategory =
  ({ setEquipmentAssets }) =>
  (index) => {
    if (index === 0) {
      setEquipmentAssets((preData) => (preData.length === 1 ? [emptyEquipment] : [...preData.slice(1)]));
    } else {
      setEquipmentAssets((preData) => [...preData.slice(0, index), ...preData.slice(index + 1)]);
    }
  };

const handleAddAsset =
  ({ setEquipmentAssets }) =>
  ({ categoryId, model, assetId, localCode, remark }) =>
    setEquipmentAssets((preData) => {
      let tempData = [...preData];
      let newAsset = {
        assetId,
        localCode,
        model,
        remark,
      };

      // 已存在對應的category
      if (_.some(tempData, (item) => item.category === categoryId)) {
        let index = _.findIndex(tempData, (item) => item.category === categoryId);

        // 存在對應的 assetId
        if (_.some(tempData[index].assets, (item) => item.assetId === assetId)) {
          alertMsg(i18n.t('EQUIPMENT_VIEWREQUEST_ASSET_ERROR_MSG'), 'assetId', 'warning');
          return tempData;
        } else {
          // 不存在對應的 assetId
          let loanQty = tempData[index].loanQty;
          let assets = tempData[index].assets;
          if (assets.length < loanQty) {
            tempData[index].assets.push(newAsset);
          }
        }
      } else {
        alertMsg(i18n.t('EQUIPMENT_VIEWREQUEST_INVALID_ASSET_ERROR_MSG'), 'assetId', 'warning');
      }

      return tempData;
    });

const replaceStrBmss = DWP_COMM_REMARK_BMS_S;
const replaceStrBmsm = DWP_COMM_REMARK_BMS_M;
const replaceStrBmsl = DWP_COMM_REMARK_BMS_L;
const replaceStrBmsIsfa = DWP_COMM_REMARK_BMS_ISFA;

const replaceHandler = (oldReplaceValue, newReplaceValue, value, enter, temp) => {
  const reg = new RegExp(oldReplaceValue, 'g');
  let str;
  if (value.target) {
    str = value.target.value.replace(reg, newReplaceValue);
  } else if (enter) {
    str = `${temp.remarks + value.replace(reg, newReplaceValue)}\n`;
  } else {
    str = `${temp.remarks + value.replace(reg, newReplaceValue)}`;
  }

  return str;
};

const judgeConstantRemark = (val, constantRemark) => val.indexOf(constantRemark) !== -1;

const handleInputRemark = ({ value, setFormData, enter }) => {
  setFormData((preData) => {
    let temp = { ...preData };
    let val = value.target ? value.target.value : value;

    if (judgeConstantRemark(val, replaceStrBmss)) {
      val = replaceHandler(replaceStrBmss, REMARKS_FIELD.BIPAP_MASK_SIZE_S, value, enter, temp);
    } else if (judgeConstantRemark(val, replaceStrBmsm)) {
      val = replaceHandler(replaceStrBmsm, REMARKS_FIELD.BIPAP_MASK_SIZE_M, value, enter, temp);
    } else if (judgeConstantRemark(val, replaceStrBmsl)) {
      val = replaceHandler(replaceStrBmsl, REMARKS_FIELD.BIPAP_MASK_SIZE_L, value, enter, temp);
    } else if (judgeConstantRemark(val, replaceStrBmsIsfa)) {
      val = replaceHandler(replaceStrBmsIsfa, REMARKS_FIELD.EXCEPT_ISOLATION_WARD, value, enter, temp);
    } else if (val.indexOf(REMARKS_FIELD.START_CODE) !== -1 && val.indexOf(REMARKS_FIELD.END_CODE) !== -1) {
      if (enter) {
        val = temp.remarks + val.replace(REMARKS_FIELD.REPLACE_REMARK_REGEX, (value) => `${value.slice(13, -12)}\n`);
      } else {
        val = value.target
          ? val.replace(REMARKS_FIELD.REPLACE_REMARK_REGEX, (value) => value.slice(13, -12))
          : temp.remarks + val.replace(REMARKS_FIELD.REPLACE_REMARK_REGEX, (value) => value.slice(13, -12));
      }
    }
    temp.remarks = val;
    return { ...temp };
  });
};

const UpdateLoanRequestDialog = ({ dialogCloseHandler, dialogFinishHandler, data, categories }) => {
  const initFormData = {
    requestID: data.requestID,
    status: data.status,
    ward: '',
    provider: '',
    providerId: '',
    patient: '',
    bedID: '',
    remarks: '',
    requestDate: null,
    loanOutDate: null,
    returnDate: null,
    adsWardLocationId: 0,
    categorySatelliteStoresId: 0,
  };
  const classes = useStyles();
  const [formData, setFormData] = useState(initFormData);
  const [otherInformationOpen, setOtherInformationOpen] = useState(true);
  const [activeLogOpen, setActiveLogOpen] = useState(true);
  const [options, setOptions] = useState({
    ward: [],
    provider: [],
    latestOrderNo: '',
    latestOrderStatus: '',
    isDisabled: '',
  });
  const [equipmentAssets, setEquipmentAssets] = useState([emptyEquipment]);
  const loginInfo = useSelector((state) => state.loginInfo);
  const [barcodeOpen, setBarcodeOpen] = useState(true);
  const [flag, setFlag] = useState(0);
  const [assetId, setAssetId] = useState('');
  const [isPad] = useMobile();
  const [errors, setErrors] = useState({ patient: '', loanOutDate: '', returnDate: '' });
  const [dialogOpen, setDialogOpen] = useState(true);
  const [warningDialogOpen, setWarningDialogOpen] = useState(false);
  const [warningCategorys, setWarningCategorys] = useState([]);
  const inputRef = useRef(null);
  const [getAdsOrderParams, setGetAdsOrderParams] = useState({ loanId: '', hospCode: '' });
  const [adsPopup, setAdsPopup] = useState(false);
  const [isTransfer, setIsTransfer] = useState(false);
  const [wardList, setWardList] = useState({});
  const [wardValue, setWardValue] = useState('');
  const [transferToValue, setTransferToValue] = useState('');
  const [initTransferToValue, setInitTransferToValue] = useState('');
  const [transferHistory, setTransferHistory] = useState([]);
  const [receipt, setReceipt] = useState(true);
  const userInfo = useGetUserInfo();
  const loginWardId = loginInfo.wardId;
  const [receiptRequire, setReceiptRequire] = useState(false);
  const [canTransfer, setCanTransfer] = useState(false);
  const adsRef = useRef(null);
  const [multiReceiptValue, setMultiReceiptValue] = useState([]);
  const [selectedCategoryWards, setSelectedCategoryWards] = useState([]);
  const [providerDisabled, setProviderDisabled] = useState(false);
  const [assetList, setAssetList] = useState([]);

  const requiredPatientHN = useMemo(() => {
    return _.some(selectedCategoryWards, (item) => String(item?.isPatientNo) === '1');
  }, [selectedCategoryWards]);

  const selectedProviderInfo = useMemo(() => {
    return _.find(options?.provider, (providerItem) => providerItem?.value === formData?.providerId) ?? {};
  }, [options, formData]);

  // 根據狀態控制
  const controller = useMemo(() => {
    let ctrl = {
      assetId: true,
      category: true,
      loanQty: true,
      asset: true,
      Decline: true,
      readOnly: false,
      requestDate: false,
      loanOutDate: false,
      returnDate: false,
      transfer: false,
    };

    switch (formData?.status) {
      case 2:
        ctrl = {
          ...ctrl,
          assetId: false,
          category: false,
          loanQty: false,
          asset: false,
          Decline: false,
          requestDate: true,
          loanOutDate: true,
        };
        break;
      case 4:
        ctrl = {
          ...ctrl,
          assetId: false,
          category: false,
          loanQty: false,
          asset: false,
          Decline: false,
          requestDate: true,
          loanOutDate: true,
          returnDate: true,
        };
        break;
      case 3:
      case 5:
        ctrl = {
          ...ctrl,
          assetId: false,
          category: false,
          loanQty: false,
          asset: false,
          Decline: false,
          readOnly: true,
        };
        break;
      case 1:
        ctrl = { ...ctrl, category: false, loanQty: false, requestDate: true };
        break;
      case 6:
        ctrl = {
          ...ctrl,
          assetId: false,
          category: false,
          loanQty: false,
          asset: false,
          Decline: false,
          requestDate: true,
          loanOutDate: true,
          transfer: true,
        };
        break;
      default:
        break;
    }

    return ctrl;
  }, [formData?.status]);

  // 当设备status是In Process 并且 设备类型只有一种时,才可以更改provider
  const getIsProviderDisabled = useCallback((detail) => {
    const isMultipleCategory = (Array.isArray(detail?.categories) && detail?.categories?.length > 1) ?? false;
    const isDisabled = detail?.status !== 1 || (detail?.status === 1 && isMultipleCategory);
    setProviderDisabled(isDisabled);
    return isDisabled;
  }, []);

  const getProvidersByWardandCategory = (currentProvider = {}, categoryId = '', equipmentAsset = {}) => {
    const categorys = currentProvider?.categorys ?? [];
    const centralStoreQty = getCentralStoreAvailableQty(categorys, equipmentAsset);
    const stores = _.find(categorys, (categoryItem) => categoryItem?.id === categoryId)?.satelliteStores ?? [];
    const centralStoreOption = [
      {
        text: `${currentProvider?.wardName}${centralStoreQty !== null ? ` (Qty: ${centralStoreQty})` : ``} `,
        value: currentProvider?.wardId,
        provideWardName: currentProvider?.wardName,
        isFloor: true,
      },
    ];
    const satelliteStoreOptions = _.map(stores, (item) => {
      return {
        text: `    ${item?.satelliteStoresName}${
          _.isNumber(item?.satelliteStoresQty) ? ` (Qty: ${item?.satelliteStoresQty})` : ``
        }`,
        value: item?.categorySatelliteStoresId,
        provideWardName: currentProvider?.wardName,
      };
    });

    return centralStoreOption.concat(satelliteStoreOptions);
  };
  // 获取provider option
  const getProviderList = useCallback(async (detail, isProviderDisabled, equipmentAsset) => {
    // 如果provider是disabled的情况
    if (isProviderDisabled) {
      return [
        {
          text: detail.satelliteStoresName ? `    ${detail.satelliteStoresName}` : detail.provideWard,
          value: detail.categorySatelliteStoresId ? detail.categorySatelliteStoresId : detail.provideWardId,
          provideWardName: detail.provideWard,
          isFloor: detail.categorySatelliteStoresId ? false : true,
        },
      ];
    }

    // 否则就显示当前这一层和当前provider下所选category的所有store
    try {
      const { result } = await equipmentAPI.getProvider({
        hospitalId: loginInfo.hospitalId,
        wardId: loginInfo.wardId,
      });
      const currentProvider = _.find(
        result?.provides,
        (providerItem) => providerItem?.wardId === detail?.provideWardId
      );
      return getProvidersByWardandCategory(currentProvider, detail?.categories?.[0]?.categoryId, equipmentAsset);
    } catch (error) {
      console.log('get provider list error: ', error);
      return [];
    }
  }, []);

  // 獲取detail
  const getDetail = useCallback(async () => {
    try {
      const { result } = await equipmentAPI.getRequestDetail({ loanId: data.requestID });
      const detail = result[0];
      setGetAdsOrderParams({ loanId: detail.loanId, hospCode: detail.hospCode });
      const { result: adsResult } = await equipmentAPI.getAdsOrder({
        loanId: detail.loanId,
        hospCode: detail.hospCode,
      });
      setTransferToValue(
        detail?.transferredWardLocationId
          ? `${detail?.transferredWardId}-${detail?.transferredWardLocationId}`
          : detail?.transferredWardId
      );
      setInitTransferToValue(detail.transferredWardId);
      setReceipt(Boolean(detail.receiptConfirmationBy));
      setMultiReceiptValue(getMutiReceiptVal(detail?.receiptConfirmationBy, 'fromApi'));
      setFormData((preData) => ({
        ...preData,
        ...detail,
        ward: detail.wardId,
        provider: detail.provideWardId,
        providerId: detail?.categorySatelliteStoresId ?? detail?.provideWardId,
        patient: detail.patientNo ?? '',
        bedID: detail.bedNo ?? '',
        remarks: detail.remark ?? '',
        status: detail.status,
        requestDate: detail.requestDate ? moment(detail.requestDate).format(EQUIPMENT_REQUEST_DATE_FORMAT) : null,
        loanOutDate: detail.transferDatetime
          ? moment(detail.transferDatetime).format(EQUIPMENT_REQUEST_DATE_FORMAT)
          : null,
        returnDate: detail.returnDatetime ? moment(detail.returnDatetime).format(EQUIPMENT_REQUEST_DATE_FORMAT) : null,
        transferredWardId: detail.transferredWardId,
        adsWardLocationId: detail.adsWardLocationId,
        categorySatelliteStoresId: detail.categorySatelliteStoresId,
      }));
      let tempAssets = _.map(detail.categories, (item) => ({
        category: item.categoryId,
        assets: _.map(item.equipments, (equipmentItem) => ({
          ...equipmentItem,
          remark: equipmentItem?.equipmentRemark,
        })),
        loanQty: item.assetCount,
        categoryName: item.categoryName,
        remark: item.remark,
      }));
      const isProviderDisabled = getIsProviderDisabled(detail);
      const providerList = await getProviderList(detail, isProviderDisabled, tempAssets?.[flag]);

      setOptions({
        ward: [
          {
            text: detail.roomName
              ? `${detail.hospCode} - ${detail.requestWard} - ${detail.roomName}`
              : `${detail.hospCode} - ${detail.requestWard}`,
            value: detail.wardId,
          },
        ],
        provider: providerList,
        latestOrderNo: adsResult.latestOrderNo,
        latestOrderStatus: adsResult.latestOrderStatus,
        isDisabled: adsResult.isDisabled,
      });

      if (tempAssets.length > 0) {
        setEquipmentAssets(tempAssets);
      }
    } catch (error) {
      console.log(error);
    }
  }, [data]);

  // 判断是否开启receipt
  const sameCategory = () => {
    if (isArray(categories)) {
      const arr = categories.filter((item) => equipmentAssets.some((a) => a.category === item.categoryId));

      // 提取是否必填的逻辑
      const isReceiptRequired = (arr) =>
        arr.some((item) => item.wards.some((i) => i.wardId === formData.provider && i.isReceiptConfirmation === 1));
      setReceiptRequire(isReceiptRequired(arr));

      // 提取是否可以转移的逻辑
      const isTransferAllowed = (arr) =>
        arr.some((item) => item.wards.some((i) => i.wardId === formData.provider && i.isWardTransfer === 1));
      setCanTransfer(isTransferAllowed(arr));
    }
  };
  useEffect(() => {
    sameCategory();
  }, [equipmentAssets, formData.provider]);

  // 判断是否能添加当前设备
  const getCanAddAsset = useCallback(
    (categorySatelliteStoresId) => {
      // 判断当前所选是否是楼层
      const isFloor = selectedProviderInfo?.isFloor ?? false;

      // 选了楼层并且设备属于楼层 / 选了房间并且设备属于所选房间 才可以添加
      if (
        (isFloor && categorySatelliteStoresId === null) ||
        (!isFloor && formData?.providerId === categorySatelliteStoresId)
      ) {
        return true;
      } else {
        return false;
      }
    },
    [formData.providerId, selectedProviderInfo.isFloor]
  );

  const handleHNInput = (e) => {
    formChangeHandler('patient')(e.replace(/\s*/g, ''));
    setOtherInformationOpen(true);
    setAssetId('');
  };

  const handleSpecialRemarks = (e) => {
    setOtherInformationOpen(true);
    inputRef.current.focus();
    formChangeHandler('remarks')(e);
  };

  const handleEquipmentInput = (e) => {
    handleSelectAsset(e);
  };

  const otherInformationController = () => setOtherInformationOpen((open) => !open);
  const activeLogController = () => setActiveLogOpen((value) => !value);

  // 處理 assets 相關操作
  const equipmentAssetsHandler = useCallback(({ type, flag }) => {
    switch (type) {
      case 'addEquipment':
        setEquipmentAssets((preData) => {
          return [...preData, emptyEquipment];
        });
        return;
      case 'changeCategory':
        return (value, categoryName) =>
          setEquipmentAssets((preData) => {
            let tempData = [...preData];

            tempData.splice(flag, 1, {
              ...preData[flag],
              category: value,
              categoryName,
            });
            return tempData;
          });
      case 'removeCategory':
        return handleRemoveCategory({ setEquipmentAssets });
      case 'addAsset':
        return handleAddAsset({ setEquipmentAssets });
      case 'removeAsset':
        return (id) =>
          setEquipmentAssets((preData) => {
            let tempData = [...preData];
            tempData[flag].assets = _.filter(tempData[flag].assets, (item) => item.assetId !== id);
            return tempData;
          });
      case 'updateAvailableQty':
        return (newAvailableQty) =>
          setEquipmentAssets((preData) => {
            let tempData = [...preData];
            tempData.splice(flag, 1, {
              ...preData[flag],
              availableQty: newAvailableQty,
            });
            return tempData;
          });
      case 'updateLoanQty':
        return (newLoanQty) =>
          setEquipmentAssets((preData) => {
            let tempData = [...preData];
            let assets = tempData[flag].assets;

            if (newLoanQty < assets.length) {
              return tempData;
            }

            tempData.splice(flag, 1, {
              ...preData[flag],
              loanQty: newLoanQty,
            });
            return tempData;
          });
      default:
        return;
    }
  }, []);

  const handleChangeProvider = useCallback(
    (value) => {
      // 如果 providerId 改变了， 需要把 assets 清空
      setEquipmentAssets([{ ...equipmentAssets?.[0], assets: [] }]);
      setFormData((preData) => ({ ...preData, providerId: value }));
    },
    [equipmentAssets]
  );

  // 處理 assets 以外的輸入
  const formChangeHandler = useCallback(
    (key, enter) => {
      return (value) => {
        switch (key) {
          case 'patient':
            setFormData((preData) => {
              let newValue = value;
              newValue = newValue.toUpperCase();
              newValue = newValue.replace(/[\(\)]+/g, '');
              return { ...preData, [key]: newValue };
            });
            break;
          case 'requestDate':
          case 'loanOutDate':
          case 'returnDate':
            setFormData((preData) => ({ ...preData, [key]: moment(value).format(EQUIPMENT_REQUEST_DATE_FORMAT) }));
            break;
          case 'remarks':
            handleInputRemark({ value, setFormData, enter });
            break;
          case 'providerId':
            handleChangeProvider(value);
            break;
          default:
            setFormData((preData) => ({ ...preData, [key]: value }));
            break;
        }
      };
    },
    [handleChangeProvider]
  );

  useEffect(() => {
    (async () => {
      await getDetail();
    })();
  }, []);

  // update loan request 的 API
  const updateLoanRequestAPI = useCallback(
    async ({ adsCategoryId = null, isAdsServer = null }) => {
      try {
        const providerInfo = _.find(options?.provider, (item) => item?.value === formData?.providerId);

        let params = {
          bedNo: formData.bedID ? formData.bedID : null,
          loanCategorys: _.map(
            _.filter(equipmentAssets, (item) => Boolean(item.category)),
            (item) => ({
              categoryId: item.category,
              categoryName: item.categoryName,
              assetCount: item.loanQty,
              assetIds: _.map(item.assets, (assetItem) => assetItem.assetId),
            })
          ),
          patientNo: formData.patient,
          provideWardId: formData.provider,
          remark: formData.remarks,
          wardId: formData.ward,
          loanId: data.requestID,
          provideWardName: providerInfo?.text,
          wardName: loginInfo.wardName,
          status: formData.status,
          requestDate: formData.requestDate ? moment(formData.requestDate, EQUIPMENT_REQUEST_DATE_FORMAT).valueOf() : 0,
          returnDatetime: formData.returnDate
            ? moment(formData.returnDate, EQUIPMENT_REQUEST_DATE_FORMAT).valueOf()
            : 0,
          transferDatetime: formData.loanOutDate
            ? moment(formData.loanOutDate, EQUIPMENT_REQUEST_DATE_FORMAT).valueOf()
            : 0,
          transferredWardId: transferWard ?? null,
          transferredLocationId: transferRoom ?? null,
          receiptConfirmationBy: getMutiReceiptVal(multiReceiptValue, 'toApi'),
          adsCategoryId,
          instCode: userInfo.hospCode,
          isAdsServer,
          loanType: 'BORROW',
          categorySatelliteStoresId: providerInfo?.isFloor ? null : formData.providerId,
        };

        await equipmentAPI.updateRequest(params);
        dialogFinishHandler();
      } catch (error) {
        console.log(error);
      }
    },
    [
      formData,
      equipmentAssets,
      dialogFinishHandler,
      data,
      options,
      loginInfo,
      wardValue,
      formData.status,
      multiReceiptValue,
      userInfo.hospCode,
      initTransferToValue,
    ]
  );

  // declined loan request 的 API
  const declinedLoanRequestAPI = useCallback(
    async ({ isAdsServer }) => {
      try {
        await equipmentAPI.updateRequestDeclined({
          loanId: data.requestID,
          loanStatus: 'Declined',
          instCode: userInfo.hospCode,
          isAdsServer,
        });
        dialogFinishHandler();
      } catch (error) {
        console.log(error);
      }
    },
    [data, dialogFinishHandler, controller.Decline, dialogCloseHandler, userInfo.hospCode]
  );

  // 提交表單事件
  const dialogOpenHandler = useCallback(() => {
    let tempCategorys = _.filter(
      equipmentAssets,
      (item) => item.assets.length < item.loanQty && item.assets.length > 0
    );
    if (tempCategorys.length > 0 && formData?.status === 1) {
      setWarningCategorys(_.map(tempCategorys, (item) => item.categoryName));
      setWarningDialogOpen(true);
      setDialogOpen(false);
    } else if (formData?.status === 1) {
      setAdsPopup(true);
      adsRef?.current?.getAdsLocation?.();
    } else {
      (async () => {
        await updateLoanRequestAPI({});
      })();
    }
  }, [updateLoanRequestAPI, equipmentAssets]);
  // 獲取 ward list
  const getWardList = useCallback(async () => {
    try {
      const { result } = await systemAPI.getSysHospitalWardList({ hospitalId: loginInfo.hospitalId, wardId: null });
      setWardList(result?.[0] || {});
    } catch (error) {
      console.log(error);
    }
  }, [loginInfo]);

  useEffect(() => {
    (async () => {
      await getWardList();
    })();
  }, []);

  const wardsOptions = useMemo(() => {
    let wards = [];

    if (Array.isArray(wardList?.wards)) {
      wards = _.map(wardList?.wards || [], (item) => {
        const showWardOption = item?.enableYn === 0;
        let roomOptions = [];
        const wardOption = {
          text: `${wardList?.hospitalCode} - ${item.wardName}`,
          value: item.wardId,
          tagId: item.wardId,
          wardId: item.wardId,
          adsWardLocationId: null,
        };
        const hasRoomType = _.some(item.wardLocation, (locationItem) => locationItem.adsRoomType === 'R');
        if (hasRoomType) {
          roomOptions = _.filter(item.wardLocation, (locationItem) => locationItem.adsRoomType === 'R').map(
            (locationItem) => ({
              text: `${wardList?.hospitalCode} - ${item.wardName} - ${locationItem.roomName}`,
              value: locationItem.adsWardLocationId,
              tagId: locationItem.adsWardLocationId,
              wardId: item.wardId,
              adsWardLocationId: locationItem.adsWardLocationId,
            })
          );
        }
        return showWardOption ? [wardOption, ...roomOptions] : [...roomOptions];
      }).flat();
    }

    let wardss = wards.filter((item) => item.value !== formData.ward);

    return wardss;
  }, [wardList, formChangeHandler, formData.provider, formData.ward]);
  // 转移的详细信息
  const transferDetail = _.find(wardsOptions, (item) => item.value === transferToValue);
  // 转移的病房
  const transferWard = _.get(transferDetail, 'wardId');
  // 转移的房间
  const transferRoom = _.get(transferDetail, 'adsWardLocationId');

  const changeWardValue = (value) => {
    setWardValue(value);
    setTransferToValue(value);
  };

  // assetId input 獲取/失去焦點
  const barcodeControl = useCallback(
    (props) => () => {
      setBarcodeOpen(props);
    },
    []
  );

  // cancel transfer API
  const cancelTransfer = async () => {
    try {
      await equipmentAPI.cancelTransfer({ loanId: data.requestID });
      dialogFinishHandler();
    } catch (error) {}
  };
  // confirm transfer API
  const confirmTransfer = async () => {
    try {
      await equipmentAPI.confirmTransfer({ loanId: data.requestID });
      dialogFinishHandler();
    } catch (error) {}
  };
  // reject transfer API
  const rejectTransfer = async () => {
    try {
      await equipmentAPI.rejectTransfer({ loanId: data.requestID });
      dialogFinishHandler();
    } catch (error) {}
  };
  // 获取当前时间
  const getTransferHistory = async () => {
    try {
      const { result } = await equipmentAPI.getTransferHistory({ loanId: data.requestID });
      setTransferHistory(result);
    } catch (error) {}
  };

  useEffect(() => {
    getTransferHistory();
  }, []);

  // 选择asset
  const handleSelectAsset = useCallback(
    (assetId) => {
      if (!assetId) return;
      if (!controller.assetId) return;

      // 把用 ; 号隔开的 asset Id 变成一个数组
      const assetIdList = assetId.split(';');
      _.forEach(assetIdList, async (item) => {
        const selectedAsset = _.find(assetList, (assetItem) => assetItem?.value === item);
        let newAsset = {
          categoryId: selectedAsset?.categoryId,
          assetId: selectedAsset?.assetId,
          localCode: selectedAsset?.refNo,
          model: selectedAsset?.model,
          status: selectedAsset?.status,
          remark: selectedAsset?.remark,
          categoryName: selectedAsset?.categoryName,
          categorySatelliteStoresId: selectedAsset?.categorySatelliteStoresId,
        };
        // 只有当前所选的provider下面的category的 satellite store 有查询的这个设备时才能添加
        if (getCanAddAsset(newAsset?.categorySatelliteStoresId)) {
          await equipmentAssetsHandler({ type: 'addAsset' })(newAsset);
        } else {
          alertMsg(
            i18n.t('EQUIPMENT_ADD_DIFFERENT_SATELLITE_STORE_ASSET_ERROR', {
              value: selectedProviderInfo?.text ?? '',
            }),
            'error'
          );
        }
      });
      setAssetId('');
    },
    [controller.assetId, getCanAddAsset, equipmentAssetsHandler, selectedProviderInfo, assetList]
  );

  // barcode 槍的事件
  const barcodeEvent = useCallback(
    (e) => {
      const trimmedInput = e.replace(/\s*/g, '').toUpperCase();
      if (trimmedInput.startsWith('HN')) {
        handleHNInput(e);
      } else if (
        e.indexOf(replaceStrBmss) !== -1 ||
        e.indexOf(replaceStrBmsm) !== -1 ||
        e.indexOf(replaceStrBmsl) !== -1 ||
        e.indexOf(replaceStrBmsIsfa) !== -1 ||
        (e.indexOf(REMARKS_FIELD.START_CODE) !== -1 && e.indexOf(REMARKS_FIELD.END_CODE) !== -1)
      ) {
        handleSpecialRemarks(e);
      } else if ((formData.status === 2 || formData.status === 6) && /^H\d{6,8}$/.test(trimmedInput)) {
        handleMultiReceiptEnter({ value: trimmedInput, id: getUUID() }, setMultiReceiptValue);
      } else if (e.toUpperCase().startsWith('WB ')) {
        handleScanHkid(formChangeHandler('patient'), formChangeHandler('bedID'), e);
        setOtherInformationOpen(true);
      } else {
        handleEquipmentInput(e);
      }
    },
    [formData.status, handleSelectAsset]
  );
  useBarcodeListener(barcodeEvent, barcodeOpen);

  // Scan Equipment 的組件和調用函數,返回第一個是組件，第二個是開啟的函數
  const [ScanPortal, openScanPage] = useScanPage(handleSelectAsset);
  const [ScanPortalHN, openHNScanPage] = useScanPage(
    handleScanPatientQrCode(formChangeHandler('patient'), formChangeHandler('bedID'))
  );
  const [ScanPortalRemarks, openScanPageRemarks] = useScanPage(formChangeHandler('remarks', true));
  const getBedNo = useCallback(async () => {
    try {
      if (formData.patient.replace(/\s*/g, '').startsWith('HN')) {
        const { result } = await equipmentAPI.getBedNo({
          patientNo: formData.patient.replace(/\s*/g, ''),
        });
        formChangeHandler('bedID')(result.BedNo);
      } else if (formData.patient.toUpperCase().startsWith('WB ')) {
        handleScanHkid(formChangeHandler('patient'), formChangeHandler('bedID'), formData.patient);
      } else {
        handleSelectAsset(formData.patient);
        formChangeHandler('patient')('');
      }
    } catch (error) {
      console.log(error);
    }
  }, [formData.patient, formChangeHandler, handleSelectAsset]);

  const confirmDisable = useMemo(
    () => _.some(errors, (item) => item) || (requiredPatientHN && !formData.patient),
    [errors, requiredPatientHN, formData.patient]
  );

  // 處理日期錯誤
  useEffect(() => {
    setErrors((preErrors) => {
      let tempErros = { ...preErrors };

      if (
        moment(formData.requestDate, EQUIPMENT_REQUEST_DATE_FORMAT).isAfter(
          moment(formData.loanOutDate, EQUIPMENT_REQUEST_DATE_FORMAT)
        )
      ) {
        // 借出日期比請求日期早
        tempErros.loanOutDate = 'EQUIPMENT_VIEWREQUEST_LOAN_OUT_DATE_ERROR';
      } else {
        tempErros.loanOutDate = '';
      }

      if (
        moment(formData.loanOutDate, EQUIPMENT_REQUEST_DATE_FORMAT).isAfter(
          moment(formData.returnDate, EQUIPMENT_REQUEST_DATE_FORMAT)
        )
      ) {
        // 歸還日期比借出日期早
        tempErros.returnDate = 'EQUIPMENT_VIEWREQUEST_RETURN_DATE_ERROR';
      } else if (
        moment(formData.requestDate, EQUIPMENT_REQUEST_DATE_FORMAT).isAfter(
          moment(formData.returnDate, EQUIPMENT_REQUEST_DATE_FORMAT)
        )
      ) {
        // 歸還日期比借出日期早
        tempErros.returnDate = 'EQUIPMENT_VIEWREQUEST_RETURN_DATE_ERROR2';
      } else {
        tempErros.returnDate = '';
      }

      return tempErros;
    });
  }, [formData.requestDate, formData.loanOutDate, formData.returnDate]);

  const warningDialogCancelHandler = useCallback(() => {
    setDialogOpen(true);
    setWarningDialogOpen(false);
  }, []);

  const warningDialogConfirmHandler = useCallback(() => {
    (async () => {
      await updateLoanRequestAPI({});
    })();
  }, [updateLoanRequestAPI]);

  const statusData = useMemo(
    () =>
      _.find(REQUEST_STATUS_ENUM, (item) => {
        if (formData.status === 2 && loginWardId === formData.oldRequestWardId) {
          return item.enumKey === -1;
        } else if (formData.status === 4 && loginWardId === formData.oldRequestWardId) {
          return item.enumKey === -2;
        }
        return item.enumKey === formData.status;
      }),
    [formData.status, loginWardId, formData.oldRequestWardId]
  );

  const handleOpenAdsPopup = () => {
    try {
      setAdsPopup(true);
      adsRef?.current?.getAdsLastOrder?.();
    } catch (error) {
      console.log(error);
    }
  };

  let cancelTransferText;
  if (formData.status === 6 && loginWardId === formData.wardId) {
    cancelTransferText = i18n.t('EQUIPMENT_BUTTON_CANCEL_TRANSFER');
  } else if (controller.transfer && (loginWardId === formData.provideWardId || loginWardId === initTransferToValue)) {
    cancelTransferText = i18n.t('EQUIPMENT_BUTTON_REJECT_TRANSFER');
  } else {
    cancelTransferText = false;
  }

  const adsWardInfo = useMemo(() => {
    let request = '';

    if (formData.ward) {
      request = _.find(options.ward, (item) => item.value === formData.ward)?.text ?? '';
    }

    return {
      provider: selectedProviderInfo?.text ?? '',
      request,
    };
  }, [formData.ward, formData.provider, options]);

  // 分组下的asset item
  const ListItem = useCallback(
    ({ item }) => {
      const selectedAsset = equipmentAssets?.[flag]?.assets;
      const isSelected = _.some(selectedAsset, (asset) => asset.assetId === item?.assetId);

      return (
        <div className={classes.assetItemContain} style={{ color: isSelected ? '#2E4469' : '#7D86A9' }}>
          <Box className={classes.assetItemText}>{item?.assetId}</Box>
          <Box className={classes.assetItemText}>{item?.refNo ? item?.refNo : '-'}</Box>
          <Box className={classes.assetItemText}>{item?.model ? item?.model : '-'}</Box>
        </div>
      );
    },
    [equipmentAssets?.[flag]?.assets]
  );
  const GroupHeader = useCallback(
    ({ categoryName }) => {
      const isSelectedCategory = equipmentAssets?.[flag]?.category !== '';

      return (
        <Box
          style={{
            color: '#2E4469',
            paddingLeft: 10,
            paddingTop: 12,
            paddingBottom: 8,
          }}
        >
          <Text fontWeight="400" fontSize="1rem">{`${
            !isSelectedCategory ? categoryName : ''
          } (Asset ID / Local Code / Model)`}</Text>
        </Box>
      );
    },
    [equipmentAssets?.[flag]?.category]
  );

  const assetRenderGroup = (params) => {
    const categoryName = params?.group?.split('-')?.[1] ?? '';
    return (
      <li key={params.key}>
        {params.group && <GroupHeader categoryName={categoryName} />}
        <ul style={{ paddingLeft: 0 }}>{params.children}</ul>
      </li>
    );
  };

  // 获取 equipment asset list
  const getEquipmentAsset = async (params) => {
    try {
      const { result } = await equipmentAPI.getEquipmentAssetList(params);
      const assetList = _.map(result, (assetItem) => {
        const model = assetItem?.model ?? '-';
        const localCode = assetItem?.refNo ?? '-';
        return {
          ...assetItem,
          text: `${assetItem?.assetId}   ${localCode}   ${model}`,
          value: assetItem?.assetId,
          group: `${assetItem?.categoryId}-${assetItem?.categoryName}`, // 用于下拉分组
        };
      });
      setAssetList(assetList);
    } catch (error) {
      console.log('get asset error: ', error);
    }
  };

  const { remarkList: activeRemarkList, getRemarksListAPI } = useGetRemarksListAPI();

  // 选择remark
  const handleSelectRemark = (remarks) => {
    setFormData((o = {}) => ({
      ...o,
      remarks: `${o?.remarks || ''} ${remarks}`.slice(0, 99),
    }));
  };

  useEffect(() => {
    const categoryId = formData?.categories?.[flag]?.categoryId;
    if (formData?.status === 1 && formData?.provider && categoryId && JSON.stringify(selectedProviderInfo) !== '{}') {
      const params = {
        wardId: formData.provider,
        categoryIds: [categoryId],
        satelliteStoresIds: selectedProviderInfo?.isFloor ? [] : [selectedProviderInfo?.value],
      };
      (async () => await getEquipmentAsset(params))();
    }
  }, [formData.provider, formData.status, formData.categories, flag, selectedProviderInfo]);

  useEffect(() => {
    if (assetId) {
      handleSelectAsset(assetId);
    }
  }, [assetId]);

  useEffect(() => {
    if (equipmentAssets?.[flag]?.category) {
      getRemarksListAPI({ hospitalCategoryIds: [equipmentAssets?.[flag]?.category] });
    }
  }, [equipmentAssets?.[flag]?.category]);

  return (
    <>
      {dialogOpen && <ScanPortalHN />}
      <DiaLog
        open={dialogOpen}
        handleClose={dialogCloseHandler}
        handleCancel={() => (controller.Decline ? handleOpenAdsPopup() : dialogCloseHandler())}
        handleConfirm={
          controller.transfer && (loginWardId === formData.provideWardId || loginWardId === initTransferToValue)
            ? confirmTransfer
            : dialogOpenHandler
        }
        title={i18n.t('EQUIPMENT_VIEWREQUEST_UPDATE_REQUEST_TITLE')}
        cancel={
          controller.transfer && (loginWardId === formData.provideWardId || loginWardId === initTransferToValue)
            ? false
            : conditional(
                controller.Decline,
                i18n.t('EQUIPMENT_VIEWREQUEST_UPDATE_REQUEST_DECLINE'),
                i18n.t('EQUIPMENT_VIEWREQUEST_UPDATE_REQUEST_CANCEL')
              )
        }
        cancelTransfer={cancelTransferText}
        cancelTransferStyle={{ backgroundColor: '#ff7270', border: 'none', color: '#fff' }}
        handleCancelTransfer={
          controller.transfer && (loginWardId === formData.provideWardId || loginWardId === initTransferToValue)
            ? rejectTransfer
            : cancelTransfer
        }
        confirm={
          controller.transfer && (loginWardId === formData.provideWardId || loginWardId === initTransferToValue)
            ? i18n.t('EQUIPMENT_BUTTON_CONFIRM_TRANSFER')
            : i18n.t('EQUIPMENT_VIEWREQUEST_UPDATE_REQUEST_CONFIRM')
        }
        dialogfootStyle={{ marginTop: '1rem' }}
        confirmStyle={{ backgroundColor: '#28d2ab' }}
        cancelStyle={conditional(
          controller.Decline,
          { border: 'unset', backgroundColor: '#ff7270', color: '#fff' },
          undefined
        )}
        disabled={confirmDisable}
        readOnly={controller.readOnly}
      >
        <ScanPortal />
        <ScanPortalRemarks />
        <Box display="flex" justifyContent="space-between" alignItems="center" pb="1.313rem">
          <Box display="flex" flexDirection="column" width="19.375rem" gridRowGap="0.25rem">
            <div className={classes.title}>{i18n.t('EQUIPMENT_VIEWREQUEST_UPDATE_REQUEST_ID')}</div>
            <div className={classes.requestID}>{data.requestID}</div>
          </Box>
          <Box display="flex" flexDirection="column" width="19.375rem" gridRowGap="0.25rem">
            {/* <div className={classes.title}>{i18n.t('EQUIPMENT_VIEWREQUEST_UPDATE_REQUEST_STATUS')}</div> */}
            <div className={classes.title}>{i18n.t('EQUIPMENT_REQUEST_STATUS')}</div>
            <div className={classes.status}>
              <div
                className={classes.statusIcon}
                style={{
                  backgroundColor: initValue(statusData?.color, '#fff'),
                }}
              />
              {i18n.t(initValue(statusData?.textKey, 'EQUIPMENT_VIEWREQUEST_BLANK'))}
            </div>
          </Box>
        </Box>
        <Box display="flex" justifyContent="space-between" alignItems="center" pb="1.313rem">
          <Box>
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <div className={classes.title}>
                {i18n.t('EQUIPMENT_VIEWREQUEST_UPDATE_REQUEST_WARD')} <span className={classes.star}>*</span>
              </div>
              {!isTransfer &&
                formData.status === 2 &&
                (loginWardId === formData.provideWardId || loginWardId === formData.wardId) &&
                canTransfer && (
                  <ButtonBase className={classes.addTransfer} onClick={() => setIsTransfer(true)}>
                    <AddIcon className={classes.addIcon} />
                    Transfer
                  </ButtonBase>
                )}
            </Box>
            <AutoCompleteSelect
              className={classes.wardAutoSelect}
              id="ViewRequest_autoSelect-ward"
              width="19.375rem"
              height="3.5rem"
              itemList={options.ward}
              placeholder={i18n.t('EQUIPMENT_VIEWREQUEST_UPDATE_REQUEST_WARD_PLACEHOLDER')}
              value={formData.ward}
              onChange={formChangeHandler('ward')}
              disabled={true}
            />
          </Box>
          <Box>
            <div className={classes.title}>
              {i18n.t('EQUIPMENT_VIEWREQUEST_UPDATE_REQUEST_PROVIDER')} <span className={classes.star}>*</span>
            </div>
            <AutoCompleteSelect
              className={classes.wardAutoSelect}
              id="ViewRequest_autoSelect-provider"
              width="19.375rem"
              height="3.5rem"
              itemList={options.provider}
              placeholder={i18n.t('EQUIPMENT_VIEWREQUEST_UPDATE_REQUEST_PROVIDER_PLACEHOLDER')}
              value={formData.providerId}
              onChange={formChangeHandler('providerId')}
              disabled={providerDisabled}
              whiteSpace
            />
          </Box>
        </Box>
        {isTransfer && (
          <Box marginBottom="1rem">
            <Box display="flex" justifyContent="space-between" alignItems="center" width="19.2rem">
              <div className={classes.title}>
                Transfer To <span className={classes.star}>*</span>
              </div>
              <ButtonBase className={classes.addTransfer} onClick={() => setIsTransfer(false)}>
                <CloseIcon className={classes.addIcon} />
                Cancel
              </ButtonBase>
            </Box>
            <AutoCompleteInput
              style={{ marginTop: '0.5rem' }}
              itemList={wardsOptions}
              value={wardValue}
              width="19.375rem"
              height="3.5rem"
              onChange={changeWardValue}
              placeholder="Please select"
            />
          </Box>
        )}

        {formData.status === 6 && (
          <Box marginBottom="1rem">
            <Box display="flex" justifyContent="space-between" alignItems="center" width="19.2rem">
              <div className={classes.title}>
                Transfer To <span className={classes.star}>*</span>
              </div>
            </Box>
            <AutoCompleteInput
              style={{ marginTop: '0.5rem' }}
              itemList={wardsOptions}
              value={transferToValue}
              width="19.375rem"
              height="3.5rem"
              onChange={changeWardValue}
              placeholder="Please select"
              disabled={loginWardId !== formData.wardId && loginWardId !== formData.provideWardId}
            />
          </Box>
        )}
        {options.latestOrderNo && options.latestOrderStatus && (
          <Box display="flex" justifyContent="space-between" alignItems="center" pb="0.5rem" marginBottom="1rem">
            <Box display="flex" flexDirection="column" width="19.375rem" gridRowGap="0.25rem">
              <div className={classes.title}> {i18n.t('EQUIPMENT_ADS_POPUP_LAST_ORDER')}</div>
              <div className={classes.adsContent}>{options.latestOrderNo}</div>
            </Box>
            <Box display="flex" flexDirection="column" width="19.375rem" gridRowGap="0.25rem">
              <div className={classes.title}> {i18n.t('EQUIPMENT_ADS_POPUP_LAST_STATUS')}</div>
              <div className={classes.adsContent}>
                {conditional(
                  ADS_LAST_ORDER_STATUS[options.latestOrderStatus],
                  i18n.t(ADS_LAST_ORDER_STATUS[options.latestOrderStatus]),
                  '-'
                )}
                {conditional(options.isDisabled === 'Y', i18n.t('EQUIPMENT_ADS_STATUS_DELIVERED'), '')}
              </div>
            </Box>
          </Box>
        )}
        <Box
          display="flex"
          justifyContent="space-between"
          gridColumnGap="1rem"
          mt="1.25rem"
          pb="0.938rem"
          borderBottom="solid 1px #e6e7e8"
        >
          <Box display="flex" flexDirection="column" flexBasis="33%" gridRowGap="1rem">
            <div className={classes.title}>{i18n.t('EQUIPMENT_VIEWREQUEST_UPDATE_REQUEST_REQUEST_DATE')}</div>
            {controller.requestDate ? (
              <DateTimePicker
                className={classes.timePicker}
                inputVariant="outlined"
                format={EQUIPMENT_REQUEST_DATE_FORMAT}
                variant="dialog"
                placeholder="input date"
                value={formData.requestDate ? moment(formData.requestDate, EQUIPMENT_REQUEST_DATE_FORMAT) : null}
                onChange={formChangeHandler('requestDate')}
              />
            ) : (
              <Box display="flex" height="100%" alignItems="center">
                <div className={classes.date}>{initValue(formData.requestDate, '-')}</div>
              </Box>
            )}
          </Box>
          <Box display="flex" flexDirection="column" flexBasis="33%" gridRowGap="1rem">
            <div className={classes.title}>{i18n.t('EQUIPMENT_VIEWREQUEST_UPDATE_REQUEST_LOAN_OUT_DATE')}</div>
            {controller.loanOutDate ? (
              <div>
                <DateTimePicker
                  className={
                    errors.loanOutDate ? classNames(classes.timePicker, classes.timepickerError) : classes.timePicker
                  }
                  inputVariant="outlined"
                  format={EQUIPMENT_REQUEST_DATE_FORMAT}
                  variant="dialog"
                  placeholder="input date"
                  value={formData.loanOutDate ? moment(formData.loanOutDate, EQUIPMENT_REQUEST_DATE_FORMAT) : null}
                  onChange={formChangeHandler('loanOutDate')}
                  minDate={moment(formData.requestDate, EQUIPMENT_REQUEST_DATE_FORMAT)}
                  minDateMessage=""
                />
                {errors.loanOutDate && <div className={classes.errorMsg}>{i18n.t(errors.loanOutDate)}</div>}
              </div>
            ) : (
              <Box display="flex" height="100%" alignItems="center">
                <div className={classes.date}>{formData.loanOutDate ?? '-'}</div>
              </Box>
            )}
          </Box>
          <Box display="flex" flexDirection="column" flexBasis="33%" gridRowGap="1rem">
            <div className={classes.title}>{i18n.t('EQUIPMENT_VIEWREQUEST_UPDATE_REQUEST_RETURN_DATE')}</div>
            {controller.returnDate ? (
              <div>
                <DateTimePicker
                  className={
                    errors.returnDate ? classNames(classes.timePicker, classes.timepickerError) : classes.timePicker
                  }
                  inputVariant="outlined"
                  format={EQUIPMENT_REQUEST_DATE_FORMAT}
                  variant="dialog"
                  placeholder="input date"
                  value={formData.returnDate ? moment(formData.returnDate, EQUIPMENT_REQUEST_DATE_FORMAT) : null}
                  onChange={formChangeHandler('returnDate')}
                  minDate={moment(formData.loanOutDate, EQUIPMENT_REQUEST_DATE_FORMAT)}
                  minDateMessage=""
                />
                {errors.returnDate && <div className={classes.errorMsg}>{i18n.t(errors.returnDate)}</div>}
              </div>
            ) : (
              <Box display="flex" height="100%" alignItems="center">
                <div className={classes.date}>{formData.returnDate ?? '-'}</div>
              </Box>
            )}
          </Box>
        </Box>
        {formData.status === 6 || formData.status === 2 || formData.status === 4 ? (
          <Box>
            <FormControlLabel
              control={<Checkbox />}
              label={
                <>
                  {i18n.t('EQUIPMENT_VIEWREQUEST_UPDATE_REQUEST_REQUESTOR_RECEIPT')}
                  {receiptRequire && <span className={classes.xing}>*</span>}
                </>
              }
              checked={receipt}
              onChange={(e) => setReceipt(e.target.checked)}
              className={classes.checkBox}
            />
            {receipt && (
              <MultipleInput
                placeholder="Input name or scan QR code"
                value={multiReceiptValue}
                handleEnter={(val) => handleMultiReceiptEnter(val, setMultiReceiptValue)}
                handleDelete={(val) => handleDeleteReceipt(val, setMultiReceiptValue)}
                onFocus={barcodeControl(false)}
                onBlur={barcodeControl(true)}
                readOnly={formData.status === 4}
              />
            )}
          </Box>
        ) : (
          ''
        )}

        <Box display="flex" flexDirection="column" pt="1.25rem" pb="1.25rem">
          {controller.assetId && (
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="flex-end"
              mb="1.313rem"
              gridColumnGap="1.5rem"
            >
              <Box flexBasis="100%">
                <div className={classes.title} style={{ marginBottom: '1.0rem' }}>
                  {i18n.t('EQUIPMENT_VIEWREQUEST_UPDATE_REQUEST_ASSET_ID')}
                </div>
                <AutoCompleteInput
                  id="equipment-input-asset"
                  placeholder={i18n.t('EQUIPMENT_VIEWREQUEST_UPDATE_REQUEST_ASSET_ID_PLACEHOLDER')}
                  onFocus={barcodeControl(false)}
                  onBlur={barcodeControl(true)}
                  value={null}
                  onChange={(val, clearInputValueFun) => {
                    setAssetId(val);
                    if (_.isFunction(clearInputValueFun)) {
                      clearInputValueFun();
                    }
                  }}
                  itemList={assetList}
                  renderGroup={assetRenderGroup}
                  renderOption={(props) => <ListItem item={props} />}
                  disabledSelectionAutoCompletion={true}
                  whiteSpace
                />
              </Box>
              {isPad && (
                <StyleButton
                  id="equipment-button-scan-asset"
                  className={classes.scanButton}
                  width="14.125rem"
                  text={i18n.t('EQUIPMENT_VIEWREQUEST_UPDATE_REQUEST_SCAN_EQUIPMENT')}
                  Icon={ScanIcon}
                  iconStyle={{ fontSize: '1.5rem', marginRight: '0.75rem' }}
                  onClick={openScanPage}
                />
              )}
            </Box>
          )}
          <EquipmentAsset
            data={equipmentAssets}
            flag={flag}
            setFlag={setFlag}
            changeDataHandler={equipmentAssetsHandler}
            provider={formData.provider}
            status={formData.status}
            controller={controller}
            modelB={formData.status === 3}
            setSelectedCategoryWards={setSelectedCategoryWards}
            categorySatelliteStoresId={selectedProviderInfo?.isFloor ? null : selectedProviderInfo.value}
          />
        </Box>
        <Box
          id="equipment-button-otherinformation"
          className={classes.otherInfoBtn}
          display="flex"
          p="1.125rem 0.813rem"
          borderTop="solid 1px #e6e7e8"
          borderBottom="solid 1px #e6e7e8"
          onClick={otherInformationController}
        >
          <div className={classes.dropDownButton}>
            {otherInformationOpen ? (
              <DropUpIcon className={classes.dropDownIcon} />
            ) : (
              <DropDownIcon className={classes.dropDownIcon} />
            )}
          </div>
          <div className={classes.otherInformationTitle}>
            {i18n.t('EQUIPMENT_VIEWREQUEST_UPDATE_REQUEST_OTHER_INFORMATION')}
          </div>
        </Box>
        {otherInformationOpen && (
          <Box display="flex" flexDirection="column" p="1rem 0 1.5rem" borderBottom="solid 1px #e6e7e8">
            <Box display="flex" justifyContent="space-between" mb="1.25rem">
              <TitleInput
                id="equipment-input-patient"
                title={i18n.t('EQUIPMENT_VIEWREQUEST_UPDATE_REQUEST_PATIENT_HN')}
                placeholder={i18n.t('EQUIPMENT_VIEWREQUEST_UPDATE_REQUEST_PATIENT_HN_PLACEHOLDER')}
                flexBasis="48%"
                endAdornment={
                  isPad ? (
                    <ButtonBase
                      id="equipment-button-patient"
                      onClick={() => {
                        (async () => {
                          await openHNScanPage();
                        })();
                      }}
                    >
                      <ScanIcon className={classes.scanIcon} />
                    </ButtonBase>
                  ) : (
                    <div />
                  )
                }
                value={formData.patient}
                onChange={formChangeHandler('patient')}
                length={EQUIPMENT_LENGTH.REQUEST_HN}
                handleEnter={getBedNo}
                onFocus={barcodeControl(false)}
                onBlur={() => {
                  barcodeControl(true)();
                  setFormData((preData) => ({ ...preData, patient: preData.patient.replace(/\s*/g, '') }));
                }}
                error={Boolean(errors.patient)}
                errorMsg={errors.patient}
                readOnly={controller.readOnly}
                required={requiredPatientHN}
              />
              <TitleInput
                id="equipment-input-bed"
                title={i18n.t('EQUIPMENT_VIEWREQUEST_UPDATE_REQUEST_BED_ID')}
                placeholder={i18n.t('EQUIPMENT_VIEWREQUEST_UPDATE_REQUEST_BED_ID_PLACEHOLDER')}
                flexBasis="48%"
                value={formData.bedID}
                onChange={formChangeHandler('bedID')}
                length={EQUIPMENT_LENGTH.REQUEST_BED}
                readOnly={controller.readOnly}
              />
            </Box>

            <Box
              display="flex"
              justifyContent="space-between"
              flexDirection="column"
              // alignItems="flex-end"
              mb="1.313rem"
            >
              <Box display="flex" justifyContent="space-between">
                <div className={classes.title}>{i18n.t('EQUIPMENT_VIEWREQUEST_UPDATE_REQUEST_REMARK')}</div>
                <AddRemarks list={activeRemarkList} handleSelect={handleSelectRemark} />
              </Box>
              <Box display="flex" gridColumnGap="1.5rem">
                <TextField
                  id="ViewRequest-input-remark"
                  className={classes.textField}
                  placeholder={i18n.t('EQUIPMENT_VIEWREQUEST_UPDATE_REQUEST_REMARK_PLACEHOLDER')}
                  multiline={true}
                  fullWidth={true}
                  rows={4}
                  value={formData.remarks}
                  onChange={formChangeHandler('remarks')}
                  style={{ marginTop: '1rem' }}
                  readOnly={controller.readOnly}
                  inputRef={inputRef}
                  onFocus={() => setBarcodeOpen(false)}
                  onBlur={() => setBarcodeOpen(true)}
                />
                {isPad && (
                  <StyleButton
                    id="ViewRequest-button-scan-remark"
                    className={classes.scanButton}
                    width="14.125rem"
                    text={i18n.t('EQUIPMENT_VIEWREQUEST_NEW_REQUEST_SCAN_EQUIPMENT')}
                    Icon={ScanIcon}
                    iconStyle={{ fontSize: '1.5rem', marginRight: '0.75rem' }}
                    onClick={openScanPageRemarks}
                  />
                )}
              </Box>
            </Box>
            {/* <TitleInput
              id="equipment-input-remark"
              title={i18n.t('EQUIPMENT_VIEWREQUEST_UPDATE_REQUEST_REMARK')}
              placeholder={i18n.t('EQUIPMENT_VIEWREQUEST_UPDATE_REQUEST_REMARK_PLACEHOLDER')}
              value={formData.remarks}
              onChange={formChangeHandler('remarks')}
              length={EQUIPMENT_LENGTH.REQUEST_REMARK}
              readOnly={controller.readOnly}
            /> */}
          </Box>
        )}
        {/*  */}
        <Box
          id="equipment-button-activeLog"
          className={classes.otherInfoBtn}
          display="flex"
          p="1.125rem 0.813rem"
          borderBottom="solid 1px #e6e7e8"
          onClick={activeLogController}
        >
          <div className={classes.dropDownButton}>
            {activeLogOpen ? (
              <DropUpIcon className={classes.dropDownIcon} />
            ) : (
              <DropDownIcon className={classes.dropDownIcon} />
            )}
          </div>
          <div className={classes.otherInformationTitle}>{i18n.t('EQUIPMENT_ACTIVITY_LOG')}</div>
        </Box>
        {activeLogOpen && <TransferHistory transferHistoryLogList={transferHistory} />}
      </DiaLog>
      {warningDialogOpen && (
        <WarningPopup
          categorys={warningCategorys}
          onCancel={warningDialogCancelHandler}
          onConfirm={warningDialogConfirmHandler}
        />
      )}
      <SingleADSDialog
        handleNewRequest={updateLoanRequestAPI}
        handleDelete={declinedLoanRequestAPI}
        equipmentAssets={equipmentAssets}
        formData={formData}
        handleClose={() => setAdsPopup(false)}
        adsType="withdraw"
        adsWardInfo={adsWardInfo}
        getAdsOrderParams={getAdsOrderParams}
        adsPopup={adsPopup}
        ref={adsRef}
        provideWardId={formData.provider}
        requestWard={formData.ward}
        adsWardLocationId={formData.adsWardLocationId}
        categorySatelliteStoresId={selectedProviderInfo?.isFloor ? null : selectedProviderInfo.value}
      />
    </>
  );
};

const WarningPopup = ({ onCancel, onConfirm, categorys }) => {
  const classes = useStyles();
  return (
    <DiaLog
      open={true}
      handleClose={onCancel}
      handleCancel={onCancel}
      handleConfirm={onConfirm}
      cancel={i18n.t('EQUIPMENT_VIEWREQUEST_CATEGORY_WARN_CANCEL')}
      confirm={i18n.t('EQUIPMENT_VIEWREQUEST_CATEGORY_WARN_OK')}
      title={i18n.t('EQUIPMENT_VIEWREQUEST_UPDATE_REQUEST_TITLE')}
      // confirmStyle={{ backgroundColor: '#28d2ab' }}
      // cancelStyle={controller.Decline ? { border: 'unset', backgroundColor: '#ff7270', color: '#fff' } : undefined}
    >
      <div
        className={classes.warningContent}
        dangerouslySetInnerHTML={{
          __html: i18n.t('EQUIPMENT_VIEWREQUEST_CATEGORY_WARN_MSG', { value: categorys.join() }),
        }}
      />
    </DiaLog>
  );
};

export default UpdateLoanRequestDialog;
